<template>
  <div v-if="userData" class="user-info">
    <p>{{ userData.firstName }} {{ userData.lastName }}</p>
    <p>
      {{ userData.email }}
    </p>
    <p>
      {{ getUserRoles() }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { IUser, Role } from 'types';
  import { ref } from 'vue';
  import { watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'vuex';

  const { t } = useI18n();
  const store = useStore();

  const userData = ref<IUser>();
  const userRoles = ref<Role[]>();

  function getUserRoles() {
    const translatedRoles = userRoles.value?.map((role) =>
      t(`roles.${role}`, 1),
    );
    return translatedRoles?.join(', ');
  }

  watch(
    () => store.state.userData,
    () => {
      userData.value = store.state.userData;
    },
    { immediate: true },
  );
  watch(
    () => store.state.userRoles,
    () => {
      userRoles.value = store.state.userRoles;
    },
    { immediate: true },
  );
</script>

<style scoped lang="scss">
  .user-info {
    max-width: 800px;
    width: max-content;
    padding: 10px 20px;
    text-align: center;

    p {
      margin: 0;
    }
  }
</style>
